exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EnableMemberModal_FormTitle_3ITEg {\n    color: #337ab7;\n    margin: auto;\n    align-items: left;\n    display: flex;\n    flex-flow: row;\n    justify-content: left;\n    font-size: 18px;\n    font-weight: bolder;\n    margin: 10px 0px 0 10px;\n}\n\n.EnableMemberModal_Label_JxzIR {\n    margin: auto;\n    align-items: left;\n    flex-flow: row;\n    justify-content: left;\n    margin-left:10px;\n    font-weight: bolder;\n}", ""]);

// Exports
exports.locals = {
	"FormTitle": "EnableMemberModal_FormTitle_3ITEg",
	"Label": "EnableMemberModal_Label_JxzIR"
};